import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchInventoryStatus = () => apiActionCreator({
  'endpoint': '/warehouses/lines',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_INVENTORY_STATUS,
    ActionTypes.FETCHED_INVENTORY_STATUS,
    [
      ActionTypes.FETCHED_INVENTORY_STATUS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchInventoryStatusDetail = () => apiActionCreator({
  'endpoint': '/warehouses/lines/classification',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_INVENTORY_STATUS_DETAIL,
    ActionTypes.FETCHED_INVENTORY_STATUS_DETAIL,
    [
      ActionTypes.FETCHED_INVENTORY_STATUS_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchLinesInfo = (initialDate, finalDate) => apiActionCreator({
  'endpoint': `/warehouses/moves?initialDate=${initialDate}&finalDate=${finalDate}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_LINES_INFO,
    ActionTypes.FETCHED_LINES_INFO,
    [
      ActionTypes.FETCHED_LINES_INFO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchLinesInfoWithDetail = ({initialDate, finalDate, lineType}, filter, search = '') => apiActionCreator({
  'endpoint': `/warehouses/moves?initialDate=${initialDate}&finalDate=${finalDate}` +
  `&type=${lineType}&filter=${filter}&search=${search}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_LINES_INFO_WITH_DETAIL,
    {
      'type': ActionTypes.FETCHED_LINES_INFO_WITH_DETAIL,
      'payload': lineType,
    },
    [
      {
        'type': ActionTypes.FETCHED_LINES_INFO_WITH_DETAIL_FAILED,
        'payload': lineType,
      },
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const downloadLinesFile = ({initialDate, finalDate, lineType}, filter, search = '') => apiActionCreator({
  'endpoint': `/warehouses/moves/excel?initialDate=${initialDate}&finalDate=${finalDate}` +
  `&type=${lineType}&filter=${filter}&search=${search}`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOADING_LINES_FILE,
    {
      'type': ActionTypes.DOWNLOADED_LINES_FILE,
      'payload': lineType,
    },
    [
      {
        'type': ActionTypes.DOWNLOADED_LINES_FILE_FAILED,
        'payload': lineType,
      },
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});


export const setSearchParamDetailKpi = (searchParam) => {
  return {
    'type': ActionTypes.SET_SEARCH_PARAM_DETAIL,
    'payload': searchParam,
  };
};

export const clearLinesInfo = () => ({
  'type': ActionTypes.CLEAR_LINES_INFO,
});

export const clearUrlLinesFile = () => ({
  'type': ActionTypes.CLEAR_URL_LINES_FILE,
});
